/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileSearch} from '@fortawesome/pro-duotone-svg-icons';

const ObservationsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileSearch} {...props} />
);

export default ObservationsIcon;
